import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-file-edit",
  templateUrl: "./med-icon-file-edit.component.html",
})
export class MedIconFileEditComponent extends SvgMixinComponent {}
